import { render, staticRenderFns } from "./PetTemperament.vue?vue&type=template&id=f4559434&scoped=true&"
import script from "./PetTemperament.vue?vue&type=script&lang=js&"
export * from "./PetTemperament.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../registration-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4559434",
  null
  
)

export default component.exports